import React, { useState, useEffect, useRef } from 'react';
import s from '../Test.module.css';
import { useAuth } from '../context/AuthContext';
import { useAppTranslation } from "./TranslationContext";
import { useParams, Link } from "react-router-dom";

export const Test = () => {
  const { user, userKursData, setUserKursData } = useAuth();
  const { kursId, id, themes, nextLessonId } = useParams();
  const { t } = useAppTranslation();
  const lang = localStorage.getItem('language') || 'uz';

  const [questions, setQuestions] = useState([]);
  const [current, setCurrent] = useState(0);
  const [selected, setSelected] = useState(null);
  const [score, setScore] = useState(0);
  const [finished, setFinished] = useState(false);
  const [totalTime, setTotalTime] = useState(180);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [minScore, setMinScore] = useState(0);
  const [currentTartib, setCurrentTartib] = useState(0);
  const [dostup, setDostup] = useState(false);

  const answersRef = useRef([]);
  const loadedRef = useRef(false);

  /* dostup */
  useEffect(() => {
    const fetchDostup = async () => {
      try {
        const localUser = JSON.parse(localStorage.getItem('user'));
        const gruhId = localUser?.gruh;
        if (!gruhId) return;
        const res = await fetch(`https://api.aiassessment.uz/api/gruh/${gruhId}/`);
        if (!res.ok) return;
        const data = await res.json();
        setDostup(data.dostup);
      } catch (error) {
        console.error("Ошибка загрузки группы:", error);
      }
    };
    fetchDostup();
  }, []);

  /* load test data */
  useEffect(() => {
    if (loadedRef.current) return;
    loadedRef.current = true;

    const loadTestData = async () => {
      try {
        const countRes = await fetch(`https://api.aiassessment.uz/api/kurs-mavzulari/${id}/`);
        const countData = await countRes.json();
        const testCount = countData.test_soni;
        setMinScore(countData.test_min_soni);
        setCurrentTartib(countData.tartib);

        const testsRes = await fetch(`https://api.aiassessment.uz/api/kurs-mavzu-test/?mavzu=${id}`);
        const testsData = await testsRes.json();

        if (!testsData.length) {
          setQuestions([]);
          setLoading(false);
          return;
        }

        const shuffled = [...testsData].sort(() => 0.5 - Math.random());
        const selectedTests = shuffled.slice(0, testCount);

        const makeAnswers = (item) => ({
          uz: [
            { text: item.V1_uz, isCorrect: true },
            { text: item.V2_uz, isCorrect: false },
            { text: item.V3_uz, isCorrect: false },
            { text: item.V4_uz, isCorrect: false },
          ],
          ru: [
            { text: item.V1_ru, isCorrect: true },
            { text: item.V2_ru, isCorrect: false },
            { text: item.V3_ru, isCorrect: false },
            { text: item.V4_ru, isCorrect: false },
          ],
          en: [
            { text: item.V1_en, isCorrect: true },
            { text: item.V2_en, isCorrect: false },
            { text: item.V3_en, isCorrect: false },
            { text: item.V4_en, isCorrect: false },
          ]
        });

        const preparedQuestions = selectedTests.map(item => ({
          question: item[`test_savol_${lang}`],
          answers: makeAnswers(item)[lang].sort(() => 0.5 - Math.random()),
          testId: item.id,
        }));

        setQuestions(preparedQuestions);
        setTotalTime(testCount * 60);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    loadTestData();
  }, [kursId, id, lang]);

  /* timer */
  useEffect(() => {
    if (finished) return;
    const timer = setInterval(() => {
      setTotalTime(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          handleFinish();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [finished]);

  const handleNext = () => {
    const currentQuestionObj = questions[current];
    const selectedAnswer = currentQuestionObj.answers[selected];
    const isCorrect = selectedAnswer?.isCorrect;

    if (isCorrect) setScore(prev => prev + 1);

    answersRef.current.push({
      user: user?.id,
      test: currentQuestionObj.testId,
      V: selectedAnswer?.text,
      javob_xolati: isCorrect,
    });

    setSelected(null);

    if (current + 1 < questions.length) {
      setCurrent(prev => prev + 1);
    } else {
      handleFinish();
    }
  };

  const handleFinish = async () => {
    setFinished(true);

    for (const answer of answersRef.current) {
      try {
        const response = await fetch("https://api.aiassessment.uz/api/kurs-mavzu-test-natija/", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(answer),
        });
        if (!response.ok) throw new Error(`Ошибка отправки ответа: ${response.status}`);
      } catch (err) {
        console.error(err.message);
      }
    }

    if (score >= minScore) {
      try {
        let kursData = userKursData;
        if (!kursData) {
          const res = await fetch(`https://api.aiassessment.uz/api/user-kurs/?user=${user?.id}&kurs=${kursId}`);
          const data = await res.json();
          kursData = data[0];
        }
        if (!kursData) throw new Error("Нет данных о курсе");
        if (parseInt(kursData.mavzu) === parseInt(currentTartib)) {
          const patchRes = await fetch(`https://api.aiassessment.uz/api/user-kurs/${kursData.id}/`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              user: user?.id,
              kurs: parseInt(kursId),
              mavzu: parseInt(currentTartib) + 1,
            }),
          });
          if (!patchRes.ok) throw new Error("Ошибка сохранения прогресса");
          setUserKursData({ ...kursData, mavzu: parseInt(currentTartib) + 1 });
        }
      } catch (err) {
        console.error(err.message);
      }
    }
  };

  /* ── States ── */
  if (loading) return <div className={s.loadingPage}>Yuklanmoqda...</div>;
  if (error)   return <div className={s.loadingPage} style={{ color: '#ff4444' }}>Xatolik: {error}</div>;
  if (questions.length === 0) return <div className={s.loadingPage}>Savollar topilmadi.</div>;

  /* ── Result screen ── */
  if (finished) {
    const pct = Math.round(score / questions.length * 100);
    const passed = score >= minScore;
    const currentId = parseInt(currentTartib);
    const themesId = parseInt(themes);

    return (
      <div className={s.resultPage}>
        <div className={`${s.resultScore} ${!passed ? s.resultScoreFail : ''}`}>
          {pct}%
        </div>
        <span className={s.resultLabel}>{t('result')}</span>
        <p className={s.resultDetail}>
          {t('answer1')} {score} {t('answer2')} {questions.length} {t('answer3')}
        </p>
        <p className={s.resultSubDetail}>
          {passed ? '✓ '+ t('Passed') : `Min: ${minScore} / ${questions.length}`}
        </p>

        <div className={s.resultLinks}>
          <Link to={`/lesson/${kursId}/${id}`} className={s.btnBack}>
            {t('backLesson')}
          </Link>

          {passed && currentId !== themesId && (
            <Link to={`/lesson/${kursId}/${nextLessonId}`} className={s.btnForward}>
              <span className={s.btnForwardText}>{t('forward')}</span>
            </Link>
          )}

          {passed && userKursData?.mavzu > themesId && currentId === themesId && dostup && (
            <Link to={`/Yakuniy/${kursId}`} className={s.btnForward}>
              <span className={s.btnForwardText}>{t('testFinish')}</span>
            </Link>
          )}
        </div>

        {totalTime === 0 && (
          <p className={s.timeOverMsg}>{t('timeOver')}</p>
        )}
      </div>
    );
  }

  /* ── Active quiz ── */
  const currentQuestion = questions[current];
  const progress = (current / questions.length) * 100;
  const minutes = Math.floor(totalTime / 60);
  const seconds = totalTime % 60;
  const formattedTime = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  const isWarning = totalTime <= 30;

  return (
    <div className={s.page}>

      {/* Header */}
      <div className={s.header}>
        <div className={s.headerMeta}>
          <span className={s.questionCounter}>
            {current + 1} / {questions.length}
          </span>
          <span className={`${s.timer} ${isWarning ? s.timerWarning : ''}`}>
            {formattedTime} {t('left')}
          </span>
        </div>
        <div className={s.progressTrack}>
          <div className={s.progressFill} style={{ width: `${progress}%` }} />
        </div>
      </div>

      {/* Question + Answers */}
      <div className={s.main}>
        <p
          className={s.question}
          dangerouslySetInnerHTML={{ __html: currentQuestion.question }}
        />

        <div className={s.answers}>
          {currentQuestion.answers.map((answer, idx) => (
            <button
              key={idx}
              className={`${s.answerBtn} ${selected === idx ? s.answerBtnSelected : ''}`}
              onClick={() => setSelected(idx)}
              dangerouslySetInnerHTML={{ __html: answer.text }}
            />
          ))}
        </div>

        <button
          className={s.nextBtn}
          onClick={handleNext}
          disabled={selected === null}
        >
          <span className={s.nextBtnText}>
            {current === questions.length - 1 ? t('finish') : t('next')}
          </span>
        </button>
      </div>

    </div>
  );
};
